// removed by extract-text-webpack-plugin
module.exports = {"spacing-medium":"8px","spacing-large":"16px","this":"NavigationMenu__this___2_j66"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/NavigationMenu.css
// module id = 2020
// module chunks = 0 1